/**
 * Enum representing the different question flow types available in the questionnaire
 */
export enum QuestionFlowEnum {
  QUICK = 'quick',
  DEEP_DIVE = 'deepDive',
}

/**
 * Enum representing the different form flow variants.
 * Used as the single source of truth for form type identity across
 * step logic, tracking, analytics, and feature routing.
 */
export enum FormTypeEnum {
  LONG_FORM = 'long_form',
  SHORT_FORM = 'short_form',
  ADDRESS_AT_END = 'address_at_end',
  HOME_INFO = 'home_info',
}
